module.exports = __webpack_public_path__ + "e4eb80ed734f8bd485729d6024e7dbcd.png";